var map = {
	"./wp_0.png": 29,
	"./wp_1.png": 30,
	"./wp_2.png": 31,
	"./wp_3.png": 32,
	"./wp_4.png": 33,
	"./wp_5.png": 34,
	"./wp_6.png": 35,
	"./wp_7.png": 36,
	"./wp_8.png": 37
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/wp_.*\.png$
// module id = 28
// module chunks = 0